import { Button, MenuItem, Tooltip } from '@blueprintjs/core';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './Navigation.module.css';
import { ApplicationContext } from '../../store/context';
import { Select } from '@blueprintjs/select';
import { useAvailableMarketCountries } from '../ResolveMarketCountryFromAuth';
import { BlueprintIcons_16Id } from '@blueprintjs/icons/lib/esm/generated/16px/blueprint-icons-16';
import fi from './flags/fi.svg';
import no from './flags/no.svg';
import se from './flags/se.svg';
import dk from './flags/dk.svg';

const marketCountryOptions: {
  value: string;
  flag: BlueprintIcons_16Id | JSX.Element;
}[] = [
  {
    value: 'FI',
    flag: <img alt="FI" width="16" src={fi} />,
  },
  {
    value: 'NO',
    flag: <img alt="NO" width="16" src={no} />,
  },
  {
    value: 'SE',
    flag: <img alt="SE" width="16" src={se} />,
  },
  {
    value: 'DK',
    flag: <img alt="DK" width="16" src={dk} />,
  },
];
export function MarketCountrySelect() {
  const { state, dispatch } = useContext(ApplicationContext);
  const countries = useAvailableMarketCountries();
  const items = marketCountryOptions.filter(
    ({ value }) => countries.includes(value) || state.marketCountry === value
  );
  const active = items.find(({ value }) => value === state.marketCountry);

  const disabled = useLocation().pathname.startsWith('/application');

  return (
    <Select
      disabled={!items.length || disabled}
      items={items}
      filterable={false}
      itemRenderer={(item, { handleClick, handleFocus }) => (
        <MenuItem
          key={item.value}
          text={item.value}
          disabled={!countries.includes(item.value)}
          icon={<>{item.flag}</>}
          active={state.marketCountry === item.value}
          onClick={handleClick}
          onFocus={handleFocus}
        />
      )}
      activeItem={active}
      onItemSelect={(item) =>
        dispatch({
          scope: { parentType: 'marketCountry' },
          type: 'Set market country',
          payload: item.value,
        })
      }
    >
      <Tooltip content="No countries available." disabled={items.length > 0}>
        <Tooltip
          content="Cannot switch market country when viewing an application"
          disabled={!disabled}
        >
          <Button
            small
            disabled={disabled || !items.length}
            text={
              <>
                {state.marketCountry ? (
                  <span className={styles.countryCode}>
                    {state.marketCountry}
                  </span>
                ) : (
                  <span>Select country</span>
                )}
              </>
            }
            rightIcon="caret-down"
            icon={!state.marketCountry ? 'warning-sign' : active?.flag}
          />
        </Tooltip>
      </Tooltip>
    </Select>
  );
}
